module.exports = __webpack_public_path__ + "6f7ff24d.svg";